import comp from "./SubmissionLockStatus";
export default comp;
